import AdminUserSelector from "./AdminUserSelector";

export default AdminUserSelector;
